// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating_rating__1xiKH {\n  display: flex;\n  align-items: center;\n}\n.rating_rating__1xiKH span {\n  padding: 0 13px;\n  border-radius: 30px;\n  font-weight: bold;\n  font-size: 14px;\n  margin-right: 0.5em;\n}\n.rating_rating__1xiKH svg {\n  cursor: pointer;\n}\n\n.rating_overlay__4meTA h1 {\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 200;\n  text-transform: uppercase;\n  border-bottom: 1px solid var(--white-20);\n}\n.rating_overlay__4meTA .rating_ratingRow__3ofDI {\n  display: flex;\n  align-items: center;\n  margin: 1em;\n}\n.rating_overlay__4meTA .rating_circle__2Baoe {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  margin-right: 0.5em;\n}", ""]);
// Exports
exports.locals = {
	"rating": "rating_rating__1xiKH",
	"overlay": "rating_overlay__4meTA",
	"ratingRow": "rating_ratingRow__3ofDI",
	"circle": "rating_circle__2Baoe"
};
module.exports = exports;
